import styled from 'styled-components';
import { BOX_SHADOW, PRIMARY, SECONDARY } from '../../const/colors';
import { mobile_normal, mobile_title } from '../../const/fonts';

export const Container = styled.div`
	border: 1px solid ${PRIMARY};
	width: 600px;
	margin: 5rem auto;

  @media screen and (max-width: 768px) {
    width: 100%;
		height: 100vh;
    padding-top: calc(94px + 1rem);
    padding-bottom: 0;
    border: none;
    overflow-y: hidden;
  }
  @media screen and (max-height: 700px) {
    padding-bottom: 0;
  }
`;


export const ModalTitle = styled.div`
  text-align: center;
  color: #fff;
  font-size: 2rem;
  font-weight: bold;
	margin-top: 1rem;

  @media screen and (max-width: 2000px) {
    font-size: 1.5rem;
  }
  @media screen and (max-width: 1400px) {
    font-size: 1.2rem;
  }
  @media screen and (max-width: 768px) {
    font-size: ${mobile_title};
    padding: 1rem 0;
    border-top: 10px solid ${PRIMARY};
  }
`;

export const Form = styled.form`
  width: 100%;
	display: flex;
	flex-direction: column;
	text-align: initial;
	align-items: center;
	padding: 2rem;
	position: relative;

  @media screen and (max-width: 1400px) {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  @media screen and (max-width: 768px) {
    padding-top: 1rem;
    background-color: ${SECONDARY};
    height: calc(90%);

    overflow-y: scroll;
  }
  @media screen and (max-width: 480px) {
    padding: 2rem;
    padding-top: 0;
    height: calc(90%);
  }

`;

export const Row = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  @media screen and (max-width: 768px) {
	  flex-direction: column;
  }
`;

export const Button = styled.button`
	width: 60%;
	font-size: 1.1rem;
  font-weight: bold;
	border: none;
  background-color: ${PRIMARY};
  color: ${SECONDARY};
  box-shadow: ${BOX_SHADOW};
  padding: 1rem;
	margin-top: 1.5rem;
  cursor: pointer;
  transition: all .3s ease-in-out;
  
  &:hover:not(:disabled){
    background-color: #fff;
  }

  &:disabled {
    box-shadow: none;
    cursor:progress;
    opacity: 0.8;
  }
  @media screen and (max-width: 2000px) {
    font-size: 0.9rem;
    padding: 0.7rem;
  }
  @media screen and (max-width: 1600px) {
    font-size: 0.8rem;
  }
  @media screen and (max-width: 768px) {
    width: 100%;
	  font-size: ${mobile_normal};
  }
`;

export const ButtonCancel = styled(Button)`
  background-color: #C21010;
  color: #fff;
  box-shadow: none;
`;